import { ApiService } from "pwapi";

import { ADMIN_CASE_DOCUMENTS_LIST_REQUEST } from "../adminConstants";

type AdminFilters = Parameters<typeof ApiService.listAdminCaseDocuments>[0];

export const fetchAdminCaseDocuments = (payload: { filters: AdminFilters }) => {
  return {
    type: ADMIN_CASE_DOCUMENTS_LIST_REQUEST,
    payload,
  };
};
